module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-landing"
  }, [(_vm.$route.name !== 'FaqDetail') ? _c('div', [_c('div', {
    staticClass: "header",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "searchBox",
    staticStyle: {
      "align-self": "flex-end",
      "width": "100%"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticStyle: {
      "align-self": "center",
      "margin": "0 auto"
    },
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchFaqs.apply(null, arguments)
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.labelFindExactlyWhatYouAreLookingFor')))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search"
    }
  }, [_c('mu-paper', {
    staticClass: "rounded"
  }, [_c('mu-text-field', {
    attrs: {
      "inputClass": "searchInput",
      "label": "",
      "id": "search",
      "name": "search",
      "icon": "search",
      "underline-show": false,
      "full-width": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1)], 1)])])], 1)], 1)])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "whiteContainer top"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [_c('mu-paper', [_c('mu-list', _vm._l((_vm.faqs), function(faq, faqIndex) {
    return _c('mu-list-item', {
      key: 'faq' + faqIndex,
      nativeOn: {
        "click": function($event) {
          return _vm.goToFaq(faq.faq_id)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(faq.question))
      },
      slot: "title"
    })])
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelMostUseful'),
      "titleClass": "blackTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.mostUseful), function(useful, index) {
    return _c('mu-list-item', {
      key: 'index-' + useful.faq_id,
      staticStyle: {
        "align-items": "flex-start"
      },
      attrs: {
        "title": useful.question
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToFaq(useful.faq_id)
        }
      }
    }, [_c('div', {
      staticClass: "question",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n                    " + _vm._s(useful.question) + "\n                  ")])])
  }), 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "top"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress')], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'FaqDetail') ? _c('div', {
    staticClass: "faq-detail"
  }, [_c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ac3041","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Faq/Index.vue
// module id = 3691
// module chunks = 1